import React from 'react';

import { divideGrid } from 'Core/Utils/BreakPoints';
import Card from 'Core/Components/Card';

class CardList extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { list } = this.props;
    const columnSpan = {
      xl: divideGrid(list.length, 0, 4),
      lg: divideGrid(list.length, 0, 4),
      md: divideGrid(list.length, 0, 2),
    };

    const cards = list.map((card, idx) => {
      const wrapper = `grow-0 xs-12 md-${columnSpan.md} lg-${columnSpan.lg} xl-${columnSpan.xl}`;
      return <box key={idx} className={wrapper}><Card card={card} /></box>;
    });

    return (
      <row className="CardList guttered">
        {cards}
      </row>
    );
  }
};

export default CardList;



// WEBPACK FOOTER //
// ./client/Site/Ui/CardList.jsx